import { Dispatch } from "redux"
import { message } from "antd"
import { SponsoredProductAction, SponsoredProductActionType } from "../types/sponsoredProducts"

import { ApiPlacementList } from "../../api/campaignApi"
import { copy } from "../../../../helper/system.helpers.functions"
import { ICampaign } from "../../types/sponsoredProducts"
import { matchTypesEnum, stateByCampaignId } from "../../../../types/customers"
import { changeCampaignStatus } from "../../../../api-wrapper/campaigns/spCampaignApi"

const fetchSponsoredProduct = (data) => {
  return async (dispatch: Dispatch<SponsoredProductAction>) => {
    try {
      dispatch({ type: SponsoredProductActionType.FETCH_SPONSORED_PRODUCTS })
      const sponsoredProductData = await ApiPlacementList(data)
      const copySponsoredProductData = copy(sponsoredProductData)
      copySponsoredProductData.campaigns.forEach((item) => {
        const defaultRecord = sponsoredProductData.defaultTargetAcos?.find((record) =>
          item.campaignName?.includes(record.type)
        )
        if (defaultRecord) {
          item.defaultRecord = defaultRecord
        } else {
          item.defaultRecord = sponsoredProductData.defaultTargetAcos?.find(
            (data) => data.type == matchTypesEnum.ALL_OTHER
          )
        }
      })

      dispatch({
        type: SponsoredProductActionType.FETCH_SPONSORED_PRODUCTS_SUCCESS,
        payload: copySponsoredProductData,
      })
    } catch (e) {
      message.error("Failed to load campaigns")
      dispatch({
        type: SponsoredProductActionType.FETCH_SPONSORED_PRODUCTS_ERROR,
        payload: "sponsored product load error",
      })
    }
  }
}

const setCampaignData = (params) => {
  const { campaigns, placementSubResult, dataTableResult, datePeriodType } = params

  return async (dispatch: Dispatch<SponsoredProductAction>) => {
    const copyCampaignsData: ICampaign[] = copy(campaigns)
    if (placementSubResult.length) {
      copyCampaignsData.forEach((item) => {
        placementSubResult.forEach((el) => {
          if (Number(el.campaignId) === item.campaignId) {
            item.placementsData = el.placementsData
          }
        })
      })
    } else {
      dataTableResult.forEach((el) => {
        copyCampaignsData.forEach((item) => {
          if (Number(el.campaignId) === item.campaignId) {
            item.subDataTable = el.subDataTable
            item.datePeriodType = datePeriodType
          }
        })
      })
    }

    dispatch({
      type: SponsoredProductActionType.SET_CAMPAIGN_DATA,
      payload: copyCampaignsData,
    })
  }
}

const updateCampaign = (campaign) => {
  return (dispatch: Dispatch<SponsoredProductAction>) => {
    dispatch({
      type: SponsoredProductActionType.CHANGE_CAMPAIGN,
      payload: campaign,
    })
  }
}

const setCampaigns = (campaigns: ICampaign[]) => {
  return (dispatch: Dispatch<SponsoredProductAction>) => {
    dispatch({
      type: SponsoredProductActionType.SET_CAMPAIGN_DATA,
      payload: campaigns,
    })
  }
}

const fetchChangeCampaignsState = (stateByCampaignIds: stateByCampaignId[]) => {
  return async (dispatch: Dispatch<SponsoredProductAction>) => {
    try {
      await changeCampaignStatus({ stateByCampaignIds })

      dispatch({
        type: SponsoredProductActionType.FETCH_CAMPAIGN_STATE_SUCCESS,
        payload: stateByCampaignIds,
      })
    } catch (e) {
      message.error("Unable to change the campaign status")
      dispatch({
        type: SponsoredProductActionType.FETCH_CAMPAIGN_STATE_ERROR,
        payload: "Unable to change the status.",
      })
    }
  }
}

export default {
  fetchSponsoredProduct,
  setCampaignData,
  updateCampaign,
  setCampaigns,
  fetchChangeCampaignsState,
}
